export default __webpack_public_path__ + "static/media/sampleImageLocation3.68df2e84.png";